function setRegionCookie(regionCode: string) {
  document.cookie = `region=${regionCode}; expires=Sun, 1 Jan 2040 00:00:00 GMT; domain=${document.domain}; path=/`
}

export default setRegionCookie
